import React, { forwardRef } from "react";
import { twMerge } from "tailwind-merge";

const WebContainer = forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement>>(({ children, className, ...props }, ref) => {
	return (
		<div {...props} ref={ref} className={twMerge("flex w-full max-w-[1280px] m-auto px-spacing-md", className)}>
			{children}
		</div>
	);
});

WebContainer.displayName = "WebContainer";

export default WebContainer;
